$(document).ready(function () {  
  /* ========== sticky ============ 라벨 */
  $(window).resize(function(){
    scrollLabelOnOff();    /// 스크롤 라벨 
  })
  
  /* 타이어 검색, 스티키바 */
  function scrollLabelOnOff(){ 
    $(".labelscroll-area .scroll-inner").each( function(){
      $(this).hasScrollBar2(); // ture of false
    }) 
  }
  $.fn.hasScrollBar2 = function() { 
    // 스크롤 있는지 여부 판단
    var _B =  (this.prop("scrollWidth") == 0 && this.prop("clientWidth") == 0)
    || (this.prop("scrollWidth") > this.prop("clientWidth"));
    _B ? $(this).closest(".labelscroll-area").addClass("scroll_on") : $(this).closest(".labelscroll-area").removeClass("scroll_on");
    return _B
    
  };
  $(".labelscroll-area .scroll-inner").hasScrollBar2();
  

});

